var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CredentialRepository from "./CredentialRepository";
import { API_BASE_URL } from "../auth/routers/AuthRouter";
const CredentialDetailRepository = {
    fetch: (id) => {
        return new Promise(((resolve) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield CredentialRepository.get(`${API_BASE_URL}/api/v1/credentials/${id}`);
            resolve({
                result: Object.assign(Object.assign({}, result.data.result), { confirmationCodeDestinationType: (result.data.result.confirmationCodeDestinationType != null ? result.data.result.confirmationCodeDestinationType : undefined), personalConfirmationCode: (result.data.result.personalConfirmationCode != null ? result.data.result.personalConfirmationCode : NaN) })
            });
        })));
    },
    save: (entity) => {
        return new Promise(() => {
            entity.id;
        });
    }
};
export default CredentialDetailRepository;
//# sourceMappingURL=CredentialDetailRepository.js.map